import React, { useState, useEffect } from 'react';
import {
  NavbarComponent,
  NavigationMenuComponent,
  AddEditContactModalFormComponent,
  InviteContactModalFormComponent,
  TypeaheadUserContactComponent,
} from '../../organisms/organisms.index';
import { AbcListComponent } from '../../atoms/atoms.index';
import { IAbcListButton } from '../../../domain/abc-list.interface';
import WishlistIconYellow from '../../../assets/icons/VARITA_AMARILLA.svg';
import {
  IContactComplete,
  IContactResume,
} from '../../../domain/contact.interface';
import { ERoutes } from '../../../assets/constants/routes';
import { useSelector, useDispatch } from 'react-redux';
import { makeSelectContacts } from '../../../store/users/users.selectors';
import {
  getContacts,
  resetUsers,
  addContact,
  editContact,
  deleteContact,
} from '../../../store/users/users.actions';
import { destroy, reset } from 'redux-form';
import { FormattedMessage } from 'react-intl';
import { EFormName } from '../../../config/form-names.config';
import { IUser } from '../../../domain/user.interface';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { inviteContacts } from '../../../store/users/users.actions';
import { IContactInvited } from '../../../domain/contact.interface';
import { returnNotification } from '../../../store/render-controller/render-controller.actions';
import { ENotification } from '../../../domain/notification.interface';
import './MyContactList.component.scss';

export function MyContactListComponent(props: any) {
  const dispatch = useDispatch();
  const contacts = useSelector(makeSelectContacts());
  const [showContactModal, setShowContactModal] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [showInviteContactModal, setShowInviteContactModal] = useState(false);
  const [contactId, setContactId] = useState<string | undefined>('');
  const [contactInfo, setContactInfo] = useState<
    IContactComplete | { user: IUser } | undefined
  >();

  const buttonListAConfig: IAbcListButton[] = [
    { image: WishlistIconYellow, action: accessToWishList },
    { icon: 'user-edit', action: handleEditContact },
    { icon: 'trash', action: handleDeleteContact },
  ];

  const buttonListBConfig: IAbcListButton[] = [
    { icon: 'user-edit', action: handleEditContact },
    { icon: 'trash', action: handleDeleteContact },
  ];

  useEffect(() => {
    dispatch(getContacts());
    // eslint-disable-next-line
  }, []);

  function handleContactModalShow() {
    setShowContactModal(true);
  }

  function handleContactModalClose() {
    setShowContactModal(false);
    setContactId('');
    setContactInfo(undefined);
  }

  function submitAddContactForm(values: IContactResume) {
    if (!Object.keys(values).length) {
      return;
    }
    handleContactModalClose();
    dispatch(addContact(values, contactId as string));
    dispatch(destroy(EFormName.ADD_EDIT_CONTACT));
    dispatch(resetUsers());
  }

  function handleAddContact(user: IUser) {
    setContactId(user.id);
    setContactInfo({ user: user });
    setEditMode(false);
    handleContactModalShow();
  }

  function submitEditContactForm(values: IContactResume) {
    if (!Object.keys(values).length) {
      return;
    }
    handleContactModalClose();
    dispatch(editContact(values, contactId as string));
    dispatch(destroy(EFormName.ADD_EDIT_CONTACT));
    dispatch(resetUsers());
  }

  function handleEditContact(contact: IContactComplete) {
    setContactId(contact.id);
    setContactInfo(contact);
    setEditMode(true);
    handleContactModalShow();
  }

  function handleInviteContactModalShow() {
    setShowInviteContactModal(true);
  }

  function handleInviteContactModalClose() {
    setShowInviteContactModal(false);
  }

  function submitInviteContactForm(values: IContactInvited) {
    dispatch(inviteContacts(values));
    dispatch(reset(EFormName.INVITE_CONTACT));
    handleInviteContactModalClose();
  }

  function accessToWishListCatalogueFormatter(item: any) {
    let itemFormatted: {
      id: string;
      name?: string;
      alias?: string;
      nickname: string | undefined;
    };
    itemFormatted = {
      id: !!item.user ? item.user.id : item.id,
      alias: item.alias,
      name: !!item.user ? item.user.name : item.name,
      nickname: !!item.user ? item.user.nickname : item.nickname,
    };
    return itemFormatted;
  }

  function accessToWishList(item: any) {
    props.history.push({
      pathname: ERoutes.CONTACT_WISH_LIST_CATALOGUE,
      state: {
        contact: accessToWishListCatalogueFormatter(item),
        readOnly: true,
      },
    });
  }

  function handleDeleteContact(contact: IContactComplete) {
    dispatch(
      returnNotification({
        type: ENotification.WARNING,
        msg1: 'warning.confirmation.message',
        dispatch: { func: deleteContact, param: [contact.id] },
      }),
    );
  }

  return (
    <div className='my-contact-container fluid-container page-container'>
      <div>
        <NavbarComponent />
        <NavigationMenuComponent {...props} />
      </div>
      <div className='content-wrapper'>
         <TypeaheadUserContactComponent
          {...props}
          onClickContact={handleEditContact}
          onClickUser={handleAddContact}
          contacts={contacts}  />
        <button
          className='add-btn mb-2'
          onClick={(e: any) => {
            e.preventDefault();
            handleInviteContactModalShow();
          }}
        >
          <FontAwesomeIcon icon='plus-circle' />{' '}
          <FormattedMessage id='pages.my-contactlist.invite-user'></FormattedMessage>
        </button>
        <div className='md-card'>
          <h4 className='subtitle mb-3'>
            <FormattedMessage id='pages.my-contactlist.list.title' />
          </h4>
          <div className='scrollable-50'>
            <AbcListComponent
              list={contacts}
              groupKey='alias'
              buttonsA={buttonListAConfig}
              buttonsB={buttonListBConfig}
            />
          </div>
        </div>
      </div>
      <AddEditContactModalFormComponent
        {...props}
        showModal={showContactModal}
        handleClose={handleContactModalClose}
        submitAddContact={submitAddContactForm}
        submitEditContact={submitEditContactForm}
        contact={contactInfo}
        propsEditMode={editMode}
      />
      <InviteContactModalFormComponent
        {...props}
        showModal={showInviteContactModal}
        handleClose={handleInviteContactModalClose}
        submitForm={submitInviteContactForm}
      />
    </div>
  );
}
